import generalTenant from '../../fields/cases/generalTenant';

export const MUTATION_UPDATE_GT_CASE = /* GraphQL */ `
	mutation($input: GeneralTenantCaseUpdate!, $id: String!) {
		updateGeneralTenantCase(input: $input, id: $id) {
			${generalTenant}
		}
	}
`;
